exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".imbee-badge[data-v-323029f7]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;z-index:9999;position:absolute;top:-4px;right:1px;color:#fff;width:20px;height:20px;border-radius:50%;display:-webkit-box;display:-moz-box;display:-ms-flexbox;display:-webkit-flex;display:flex;justify-content:center;align-items:center;padding:4px;font-size:14px;transition:all .3s ease;box-shadow:0 1px 5px rgba(31,31,31,.25);opacity:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-323029f7","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Badge.vue
// module id = 177
// module chunks = 0 1